export default function ProductImage(url, toDisplayURL) {
  return {
    url: url,
    displayUrl: toDisplayURL,
  };
}
